export enum RouteImportType {
    Project, Dashboard
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/enums/routeImportType.ts